/* ========================================================================== 
   Capilla del Rosario — Course drawer controller
   Opens course detail templates rendered by capilla-cursos-grid.liquid.
   ========================================================================== */
(() => {
  'use strict';

  const drawer = document.querySelector('[data-ccd-drawer]');
  if (!drawer) return;

  const panel = drawer.querySelector('.ccd__panel');
  const body = drawer.querySelector('[data-ccd-body]');
  const footer = drawer.querySelector('[data-ccd-footer]');
  const closeButtons = drawer.querySelectorAll('[data-ccd-close]');
  let lastTrigger = null;

  function setOpen(open) {
    drawer.classList.toggle('is-open', open);
    drawer.setAttribute('aria-hidden', String(!open));
    document.documentElement.classList.toggle('ccd-scroll-lock', open);
    document.body.classList.toggle('ccd-scroll-lock', open);

    if (open) {
      window.setTimeout(() => panel.focus(), 40);
    }
  }

  function closeDrawer() {
    if (!drawer.classList.contains('is-open')) return;
    setOpen(false);

    window.setTimeout(() => {
      body.innerHTML = '';
      footer.innerHTML = '';
      if (lastTrigger && typeof lastTrigger.focus === 'function') lastTrigger.focus();
      lastTrigger = null;
    }, 260);
  }

  function getTemplateByCourseId(courseId) {
    return Array.from(document.querySelectorAll('[data-ccd-course-template]'))
      .find((template) => template.dataset.courseId === courseId);
  }

  function openDrawer(courseId, trigger) {
    const template = getTemplateByCourseId(courseId);
    if (!template || !template.content) return;

    const content = template.content.querySelector('[data-ccd-course-content]');
    const footerTemplate = template.content.querySelector('[data-ccd-course-footer]');
    if (!content || !footerTemplate) return;

    lastTrigger = trigger || null;
    body.innerHTML = content.innerHTML;
    footer.innerHTML = footerTemplate.innerHTML;
    body.scrollTop = 0;
    setOpen(true);
  }

  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-capilla-course-drawer]');
    if (!trigger) return;

    event.preventDefault();
    const courseId = trigger.dataset.courseId;
    if (courseId) openDrawer(courseId, trigger);
  });

  closeButtons.forEach((button) => button.addEventListener('click', closeDrawer));

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && drawer.classList.contains('is-open')) {
      closeDrawer();
    }
  });
})();
